<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="店铺信息"
      edit-title
      :show-save-button="$permission.canEdit()"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="105px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
      in-dialog
    >
      <template slot="form">
        基础信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺名称" prop="ShopName">
                <el-input v-model="data.ShopName" placeholder="请输入店铺名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺编号" prop="ShopCode">
                {{ data.ShopCode }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="所属商家" prop="BusiId">
                <el-select v-model="data.BusiId" @change="busiChange" placeholder="请选择所属商家">
                  <el-option v-for="item in busiList" :key="item.RecordId" :value="item.RecordId" :label="item.BusiName" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12" v-if="biList.length">
              <el-form-item label="商街入驻店铺" prop="BstrInId">
                <el-select v-model="data.BstrInId" :disabled="!data.BusiId" placeholder="请选择商街入驻店铺" clearable>
                  <el-option v-for="item in biList" :key="item.RecordId" :value="item.RecordId" :label="item.BstrName + '-' + item.ShopNo" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-col :span="13">
                <el-form-item label="营业时间" prop="TradeTimebegin">
                  <el-time-picker
                    v-model="data.TradeTimebegin"
                    format="HH:mm"
                    value-format="HH:mm:ss"
                    placeholder="选择开始时间"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <div style="margin-top: 5px;text-align: center;">-</div>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="TradeTimeend" label-width="0">
                  <el-time-picker
                    v-model="data.TradeTimeend"
                    format="HH:mm"
                    value-format="HH:mm:ss"
                    placeholder="选择开始时间"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所在区域" prop="ShopPro">
                    <el-select v-model="data.ShopPro" placeholder="请选择" @change="proChange">
                      <el-option v-for="item in list2" :key="item.DistrictId" :value="item.Name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="ShopCity" label-width="0">
                    <el-select v-model="data.ShopCity" placeholder="请选择" @change="data.ShopArea = ''" :disabled="!data.ShopPro">
                      <el-option v-for="item in list3" :key="item.DistrictId" :value="item.Name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="ShopArea" label-width="0">
                    <el-select v-model="data.ShopArea" placeholder="请选择" :disabled="!data.ShopCity">
                      <el-option v-for="item in list4" :key="item.DistrictId" :value="item.Name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺类别" prop="ShopTypeId">
                <el-select v-model="data.ShopTypeId" @change="typeChange" placeholder="请选择店铺类别">
                  <el-option v-for="item in typeList" :key="item.RecordId" :value="item.RecordId" :label="item.TypeName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="店铺域名" prop="ShopDomino">
                {{ data.ShopDomino }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="实体店地址" prop="ShopAddress">
                <el-input v-model="data.ShopAddress" placeholder="请输入实体店地址" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
            <!--  <el-form-item label="主营描述" prop="TradeDescribe" class="is-required">
                <el-input v-model="data.TradeDescribe" type="textarea" rows="6" placeholder="请输入主营描述" clearable></el-input>
              </el-form-item>  -->

              <el-form-item label="主营描述" prop="TradeDescribe" class="is-required">
              <el-input v-model="tradeDescribe"  type="textarea" rows="3"  placeholder="请填写主营描述(按回车确认)" clearable @keyup.enter.native="addtrade"></el-input>
              <el-tag type="primary" size="small" v-for="(item,index) in tags" :key="index" closable 
                @close="tagClose(index)"  style="margin: 5px 5px 5px 0;">{{item}}</el-tag>
            </el-form-item>
            </el-col>
          </el-row>
          
          <el-row class="file-form">
          <el-col :span="24">
            <el-form-item label="实体照片" prop="EntityPhoto" class="is-required">
              <div>
                <el-upload
                  class="file-up"  
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="(res, file, fileList) => {onSuccess(res, file, fileList, 'EntityPhoto');}"
                  :headers="headers"
                  :file-list="EntityPhoto"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="(file, fileList) => {fileRemove(file, fileList, 'EntityPhoto');}"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip class="upload-tip" effect="light" content="图片格式须为jpg、png, 可上传多图" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <!-- <el-col :span="isMB?24:12">
              <el-form-item :label="isMB? '':'实体照片'" :label-width="isMB?'0':''" prop="EntityPhoto">
                <el-divider v-if="isMB">实体照片</el-divider>
                <single-pic-upload
                  v-model="data.EntityPhoto"
                  type="EntityPhoto"
                  :uploadUrl="uploadUrl"
                ></single-pic-upload>
              </el-form-item>
            </el-col>  -->
            <el-col :span="24">
              <el-form-item :label="isMB?'':'商城二维码'" :label-width="isMB?'0':''" prop="QrcodePhoto">
                <el-divider v-if="isMB">商城二维码</el-divider>
                <single-pic-upload
                  v-model="data.QrcodePhoto"
                  type="QrcodePhoto"
                  :uploadUrl="uploadUrl"
                ></single-pic-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        联系方式
        <el-row class="row-border">
          <el-form-item :label="item.ContactName" v-for="(item,index) in formData" :class="{'is-required':item.IsShow}" :key="index">
            <el-row>
              <template v-if="item.LinkType=='链接'||item.LinkType=='文字'">
                <el-col :span="isMB?24:18">
                  <el-input v-model="item.ContactDetail" :placeholder="'请输入' + item.ContactName"></el-input>
                </el-col>
              </template>
              <template v-else-if="item.LinkType=='图片'">
                <el-col :span="isMB?24:18">
                  <el-divider v-if="isMB">{{item.ContactName}}</el-divider>
                  <single-pic-upload
                    v-model="item.ContactDetail"
                    type="ContactDetail"
                    :uploadUrl="uploadUrl"
                  ></single-pic-upload>
                </el-col>
              </template>
              <template v-else-if="item.LinkType=='地图'">
                <el-col :span="isMB?24:18">
                  <el-input v-model="item.ContactDetail" placeholder="请输入纬度，经度（使用英文逗号隔开）或点击图标选点">
                    <el-button slot="append" icon="el-icon-location-outline" @click.native="onMap(item)" title="从地图选择"></el-button>
                  </el-input>
                </el-col>
              </template>
              <el-col :span="isMB?24:3" :offset="isMB?0:3">
                <el-checkbox v-model="item.IsShow">显示在导航网站</el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
        营销渠道链接类别
        <el-row class="row-border">
          <el-form-item :label="item.TypeName" v-for="(item,index) in formData2" :class="{'is-required':item.IsShow}" :key="index">
            <el-row>
              <el-col :span="isMB?24:18">
                <el-input v-if="item.LinkType=='小程序'" v-model="item.LinkDetail" placeholder="请输入小程序AppId,Secret（使用英文逗号隔开）"></el-input>
                <el-input v-else v-model="item.LinkDetail" placeholder="请输入链接地址"></el-input>
              </el-col>
              <el-col :span="isMB?24:3" :offset="isMB?0:3">
                <el-checkbox v-model="item.IsShow">显示在导航网站</el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <map-dialog ref="mapDialog" @select="selectmap" selectable></map-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import mapDialog from '@/components/common/maps/qq/mapDialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    mapDialog
  },
  props: {
    area: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    host() {
      return window.location.origin;
    },
    list2() {
      return this.area.filter((x) => x.Lv == 1);
    },
    list3() {
      if (this.id1)
        return this.area.filter((x) => x.Lv == 2 && x.Pid == this.id1);
      else return [];
    },
    list4() {
      if (this.id2)
        return this.area.filter((x) => x.Lv == 3 && x.Pid == this.id2);
      else return [];
    },
    id1() {
      if (!this.data.ShopPro) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.ShopPro);
        return obj ? obj.DistrictId : 0;
      }
    },
    id2() {
      if (!this.data.ShopCity) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.ShopCity);
        return obj ? obj.DistrictId : 0;
      }
    },
    id3() {
      if (!this.data.ShopArea) return 0;
      else {
        var obj = this.area.find((x) => x.Name == this.data.ShopArea);
        return obj ? obj.DistrictId : 0;
      }
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        ShopName: "",
        ShopCode: "",
        BusiId: "",
        TradeTimebegin: "",
        TradeTimeend: "",
        ShopTypeId: "",
        TypeName: "",
        ShopDomino: "",
        ShopAddress: "",
        TradeDescribe: "",
        EntityPhoto: "",
        QrcodePhoto: "",
        ShopPro: "",
        ShopCity: "",
        ShopArea: "",
        DataSource: 0,
        State: 1,
        DistrictId: 0,
        BstrInId: null,
        BstrName: "",
        Contacts: [],
        Links: [],
      },
      typeList: [],
      busiList: [],
      biList: [],
      formData: [],
      formData2: [],
      nowObj: {},
      tags: [],
      EntityPhoto: [],
      tradeDescribe: "",
      dialogImageUrl: '',
      dialogVisible: false,
      api: require("@/api/shop/shopdetail").default,
      api2: require("@/api/guide/shop").default, //店铺类别接口
      api3: require("@/api/shop/business").default, //商家名称接口
      api4: require("@/api/guide/contact").default,
      api5: require("@/api/guide/outlink").default,
      api6: require("@/api/bstr/bstrin").default,
      headers: { Authorization: 'Bearer ' + this.$commonJs.getCookie("token") },//传图片时加上token
      dialogImageUrl: '',
      isMB: this.$store.state.isMB,
      showEditor: false,
      rules: {
        ShopName: [{ required: true, message: "店铺名称不能为空" }],
        BusiId: [{ required: true, message: "商家名称不能为空" }],
        ShopTypeId: [{ required: true, message: "店铺类别不能为空" }],
        TradeTimebegin: [{ required: true, message: "请选择开始营业时间" }],
        TradeTimeend: [{ required: true, message: "请选择结束营业时间" }],
        // ShopDomino: [{ required: true, message: "店铺域名不能为空" }],
        ShopAddress: [{ required: true, message: "实体地址不能为空" }],
        // TradeDescribe: [{ required: true, message: "主营描述不能为空" }],
        ShopPro: [{ required: true, message: "请选择省份" }],
        ShopCity: [{ required: true, message: "请选择城市" }],
        ShopArea: [{ required: true, message: "请选择行政区" }],
       // EntityPhoto: [{ required: true, message: "实体照片不能为空" }],
        QrcodePhoto: [{ required: true, message: "商城二维码不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
      this.api4.list({State:1}).then(res => {
        if(res.Code==0) {
          res.Data.forEach(e => {
            this.formData.push({
              T: 0,
              RecordId: 0,
              ShopId: 0,
              ContactId: e.RecordId,
              ContactDetail: "",
              ContactName: e.ContactName,
              LinkType: e.LinkType,
              IsShow: false,
            })
          })
        }
      })
      this.api5.list({State:1}).then(res => {
        if(res.Code==0) {
          res.Data.forEach(e => {
            this.formData2.push({
              T: 0,
              RecordId: 0,
              ShopId: 0,
              LinkId: e.RecordId,
              LinkDetail: "",
              TypeName: e.TypeName,
              LinkType: e.LinkType,
              IsShow: false,
            })
          })
        }
      })
    },
    onEditOpened(data) {
      this.showEditor = true;
      this.getOption();
      if(!this.data.BstrInId) this.data.BstrInId = null;
      this.formData = data.Contacts.map(x => { return { ...x, T: x.RecordId?1:0, IsShow: x.State==1 }});
      this.formData2 = data.Links.map(x => { return { ...x, T: x.RecordId?1:0, IsShow: x.State==1 }});
      this.tags = data.TradeDescribe.split(",");
      if (data.EntityPhoto) {
        data.EntityPhoto.split(',').forEach(e => {
          this.EntityPhoto.push({
            url: '/api' + e,
            url2: e,
          });
        });
      }
      if(data.TradeTimebegin.length==5) {
        this.data.TradeTimebegin += ":00";
        this.data.TradeTimeend += ":00";
      }
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.typeList = res.Data;
        }
      });
      this.api3.list({ State: 1 }).then((res) => {
        if (res.Code == 0) {
          this.busiList = res.Data;
        }
      });
      if(this.data.BusiId) {
        this.api6.list({ BusiId: this.data.BusiId, State: 2, NoSelect: true }).then((res) => {
          if (res.Code == 0) {
            this.biList = res.Data;
          }
        });
      }
    },
    beforePhotoUpload(file) {
      const is500k = file.size / 1024 <= 2048;
      if (!is500k) {
        this.$message.error('照片大小不能超过2M');
      }
      return is500k;
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: '/api' + res.Data, url2: res.Data });
      } else {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error(res.Msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileRemove(file, fileList, name) {
      var index = this[name].findIndex(x => x.url == file.url);
      if (index > -1) {
        this[name].splice(index, 1);
      }
    },
    onExceed() {
      this.$message.error('超过上传数量限制');
    },
    busiChange(v) {
      this.data.BstrInId = null;
      this.loading(true);
      this.api6.list({ BusiId: this.data.BusiId, State: 2 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.biList = res.Data;
        }
      });
    },
    typeChange(v) {
      var obj = this.typeList.find(x => x.RecordId == v);
      this.data.TypeName = obj?obj.TypeName:"";
      this.data.ShopDomino = obj?obj.DomainName:"";
    },
    proChange() {
      this.data.ShopCity = "";
      this.data.ShopArea = "";
    },
    onBeforeSave() {
      if(!this.EntityPhoto.length) {
        this.$message.error("请上传实体照片");
        return false;
      }
      if(this.tags.length == 0) {
        this.$message.error("请添加主营描述标签");
        return false;
      }
      this.data.DistrictId = this.id3;
      var fd = this.formData;
      for (let i = 0; i < fd.length; i++) {
        if(!fd[i].ContactDetail && fd[i].IsShow) {
          this.$message.error('勾选"显示在导航网站"时，内容不能为空');
          return false;
        }
        if(fd[i].LinkType == "小程序" && fd[i].ContactDetail && fd[i].ContactDetail.indexOf(",") == -1) {
          this.$message.error("请输入正确的小程序信息");
          return false;
        }
        if(fd[i].LinkType == "地图" && fd[i].ContactDetail && fd[i].ContactDetail.indexOf(",") == -1) {
          this.$message.error("请输入或选择正确的经纬度");
          return false;
        }
        fd[i].ShopId = this.data.RecordId;
        fd[i].State = fd[i].IsShow?1:0;
      }
      var fd2 = this.formData2;
      for (let i = 0; i < fd2.length; i++) {
        if(!fd2[i].LinkDetail && fd2[i].IsShow) {
          this.$message.error('勾选"显示在导航网站"时，内容不能为空');
          return false;
        }
        fd2[i].LinkDetail = fd2[i].LinkDetail||"";
        fd2[i].ShopId = this.data.RecordId;
        fd2[i].State = fd2[i].IsShow?1:0;
      }
      
      var place = '';
      this.EntityPhoto.forEach((e, index) => {
        place += e.url2;
        if (index < this.EntityPhoto.length - 1) {
          place += ',';
        }
      });
      this.data.EntityPhoto = place;
      this.data.Contacts = fd;
      this.data.Links = fd2;
      if(!this.data.BstrInId) this.data.BstrInId = 0;
      // console.log(this.data);
      // return false;
      this.data.TradeDescribe = this.tags.join(",");
    },
    onMap(item) {
      this.nowObj = item;
      this.$refs.mapDialog.open({}).then(that => {
        if(item.ContactDetail) {
          var arr = item.ContactDetail.split(",");
          if(arr.length==2 && arr[0] && arr[1]) {
            that.setLocation({ lat: arr[0], lng: arr[1] });
            return;
          }
        }
        that.setLocation({ lat: 23.354349, lng: 116.681938 });
      });
    },
    selectmap(e) {
      this.nowObj.ContactDetail = e.location.lat.toFixed(6) + "," + e.location.lng.toFixed(6);
    },
    addtrade() {
      if(this.tradeDescribe) {
        this.tags.push(this.tradeDescribe);
        this.tradeDescribe = "";
      }
    },
    tagClose(index) {
      this.tags.splice(index,1);
    },
    onClosed() {
      this.typeList = [];
      this.busiList = [];
      this.biList = [];
      this.formData = [];
      this.formData2 = [];
      this.tags = [];
      this.tradeDescribe = "";
      this.EntityPhoto = [];
    },
    
  },
};
</script>
<style lang="scss" scoped>
.upload-tip {
  transform: translateY(26px);
  margin-left: 10px;
}
</style>
